import React, { useState, useEffect } from "react";
import "./index.css"

const AddPdf = (props) => {
  const myCourses = [
    {
      pdfPath: '',
    },
  ];

  const [courses, setCourses] = useState([...myCourses]);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    props.getCourses(courses);
  }, [courses]);

  useEffect(() => {
    if (props?.coursesEdit) {
      setCourses(props.coursesEdit)
    }
  }, []);


  const addCourse = () => {
    let filter = courses.filter(e => Boolean(e.pdfPath) === false);
    if (filter.length) {
      setErrors({ [courses.length - 1]: "Please select pdf!" })
    } else {
      setCourses((prevState) => {
        const initialCourse = {
          pdfPath: ''
        };

        return [...prevState, initialCourse];
      });
    }
  };
  const handleCourseChange = (courseId, value, name) => {
    setCourses((prevState) => {
      const course = prevState[courseId];
      course[name] = value;

      return [...prevState];
    });
    setErrors({})
  };
  
  const removeCourse = (courseId) => {
    setCourses((prevState) => {
      const newCourses = prevState.filter((course, i) => i != courseId);
      return [...newCourses];
    });
  };

  return (
    <>


      {courses?.map((course, i) => {
        return (
          <>
            <RenderCourse
              course={course}
              accept={props?.accept ? props?.accept : "*"}
              key={i}
              handleCourseChange={handleCourseChange}
              removeCourse={removeCourse}
              courseId={i}
            />
            <span
              style={{
                color: "red",
                top: "5px",
                fontSize: "12px",
              }}
            >
              {errors[i]}
            </span>
          </>
        );
      })}
      <div className="button-text-alignment-plus">
        <button onClick={addCourse}>Add Legal Documents</button>
      </div>
    </>
  );
};

const RenderCourse = ({
  course,
  courseId,
  accept,
  handleCourseChange,
  removeCourse,
}) => {
  const [coursepath, setcoursePath] = useState(course);
  useEffect(() => {
    setCourse(course)
  }, [course])
  const setCourse = async (data) => {
    setcoursePath(data)
  }
  const handleChange = (e) => {
    const { name, value } = e.target;
    handleCourseChange(courseId, e.target.files[0], name);
  };

  const onView = (url) => {
    window.open(url, "_blank")
  }
  return (
    <>
      <div className="input-grid-new">
        <div className="input-grid-items">
          {Boolean(coursepath.pdfPath) && typeof coursepath.pdfPath == 'string' ?
              <div className="">
                <button className="" onClick={() => onView(coursepath.pdfPath)}>
                  Click to View
                </button>
              </div>
            :
            <input
              type="file"
              className="form-control form-control-lg form-control-solid"
              name="pdfPath"
              accept={accept ? accept : '*'}
              placeholder="Enter Question"
              // value={course.pdfPath}
              onChange={handleChange}
            />}
        </div>

        <div className="input-grid-items">
          <button className="" onClick={() => removeCourse(courseId)} style={{ width:"100%"}}>
          <i className="ki ki-close icon-x"></i>
          </button>
        </div>
      </div>

    </>
  );
};


export default AddPdf;
